import { Component, Inject, Input, ViewChildren, QueryList, AfterViewInit } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { APP_CONFIG } from '../../../app.config';
import { AppConfig } from '../../../models/config/app-config';
import { AssistantPopoverService } from '../../../common/assistant-popover.service';

@Component({
  selector: 'app-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss']
})
export class DateComponent implements AfterViewInit {
  @Input() fieldId: string;
  @Input() type: string;
  @Input() control: AbstractControl;
  @Input() label: string;
  @Input() saveLastFocusedEnabled: boolean;
  @Input() fixDateEnabled: boolean;
  @Input() fixDateType: string;
  @Input() fixDateUnknownReplacement: string;
  @Input() assistantServiceEnabled: boolean;
  @Input() popOverName: string;

  @ViewChildren(NgbPopover)
  private assistantPopoverList: QueryList<NgbPopover>;

  constructor(
    private assistantPopoverService: AssistantPopoverService,
    @Inject(APP_CONFIG) public appConfig: AppConfig
  ) {}

  ngAfterViewInit(): void {
    this.assistantPopoverService.initializeAssistant(this.assistantPopoverList);
  }

  /**
   * Überprüft, ob das Eingabefeld obligatorisch ist, basierend auf den Validatoren.
   */
  isMandatory(): boolean {
    const validator = this.control?.validator?.({} as AbstractControl);
    return !!validator?.required;
  }

  /**
   * Gibt die maximale Länge des Eingabefelds basierend auf den Validatoren zurück.
   */
  getMaxLength(): number {
    if (this.control?.validator) {
      const testControl = new FormControl('');
      const errors = this.control.validator(testControl);
      return errors?.maxlength?.requiredLength ?? 5000;
    }
    return 5000;
  }

  /**
   * Überprüft, ob der Inhalt des Eingabefelds ungültig ist.
   */
  isInvalid(): boolean {
    return this.control && (this.control.dirty || this.control.touched) && !!this.control.errors;
  }

  /**
   * Deaktiviert den Assistenten.
   */
  disableAssistant() {
    this.assistantPopoverService.disableAssistant();
  }
}
